import { readMeta } from './page';

/** Must not be `_sift` — that id would shadow Sift's `window._sift` command queue. */
export const SIFT_SCRIPT_ELEMENT_ID = 'sift-science-script';

declare global {
  interface Window {
    _sift?: Array<unknown>;
  }
}

function siftQueue(): Array<unknown> {
  if (!Array.isArray(window._sift)) {
    window._sift = [];
  }
  return window._sift;
}

let siftAccountConfigured = false;

export function resetSiftTrackingState(): void {
  siftAccountConfigured = false;
}

export function shouldTrackSift(): boolean {
  const ssoUuid = readMeta('account', 'data-account');
  const trackSift = readMeta('track_sift');
  return Boolean(ssoUuid && trackSift);
}

export function injectSiftScript(): void {
  if (document.querySelector(`#${SIFT_SCRIPT_ELEMENT_ID}`)) return;

  const script = document.createElement('script');
  script.src = 'https://cdn.siftscience.com/s.js';
  script.id = SIFT_SCRIPT_ELEMENT_ID;
  document.body.appendChild(script);
}

/** Queue account, user, and session once. Pageviews are sent from the router guard. */
export function initSiftAccount(): void {
  if (!shouldTrackSift() || siftAccountConfigured) return;

  const siftKey = readMeta('sift');
  const ssoUuid = readMeta('account', 'data-account');
  const sessionID = readMeta('session');
  const sift = siftQueue();

  sift.push(['_setAccount', siftKey]);
  sift.push(['_setUserId', ssoUuid]);
  sift.push(['_setSessionId', sessionID]);
  siftAccountConfigured = true;
}

export function trackSiftPageview(): void {
  if (!shouldTrackSift()) return;

  initSiftAccount();
  siftQueue().push(['_trackPageview']);
}
